import { render, staticRenderFns } from "./StarlitEdge.vue?vue&type=template&id=202a5ea9&scoped=true"
import script from "./StarlitEdge.vue?vue&type=script&setup=true&lang=js"
export * from "./StarlitEdge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StarlitEdge.vue?vue&type=style&index=0&id=202a5ea9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202a5ea9",
  null
  
)

export default component.exports